module.exports = __webpack_public_path__ + "static/LGGlossWhiteImage-9b302bbc044b5f8c03bbc45756d2d6dc.jpg";